module.exports = __webpack_public_path__ + "static/media/789572ed.jpg";